import { SET_DEAL_STAGE_MAPPINGS, SET_FORECAST_CATEGORIES, SET_IS_CREATE_FORECAST_TYPE_WIZARD_OPEN } from '../actions/ActionTypes';
const initialStateWizard = {
  isCreateForecastTypeWizardOpen: false,
  forecastCategories: [],
  existingForecastCategories: [],
  dealStageMappings: {}
};
export function wizard(state = initialStateWizard, action) {
  switch (action.type) {
    case SET_FORECAST_CATEGORIES:
      {
        const {
          payload: {
            existing,
            updated
          }
        } = action;
        if (existing) {
          return Object.assign({}, state, {
            forecastCategories: updated,
            existingForecastCategories: existing
          });
        }
        return Object.assign({}, state, {
          forecastCategories: updated
        });
      }
    case SET_DEAL_STAGE_MAPPINGS:
      {
        const {
          payload
        } = action;
        return Object.assign({}, state, {
          dealStageMappings: payload
        });
      }
    case SET_IS_CREATE_FORECAST_TYPE_WIZARD_OPEN:
      {
        const {
          payload
        } = action;
        return Object.assign({}, state, {
          isCreateForecastTypeWizardOpen: payload
        });
      }
    default:
      return state;
  }
}